import React, { useContext } from "react";
import { View, StyleSheet } from "react-native";
import {
  NormalText,
  PrimaryButton,
  SecondaryButton,
  TitleText,
} from "../../../common/native";
import { SessionContext } from "../../../../contexts";
import { mixpanel } from "../../../../utils/mixpanel";

type DeployWidgetNudgeModalProps = {
  onClose: () => void;
};

const DeployWidgetNudgeModal: React.FC<DeployWidgetNudgeModalProps> = ({
  onClose,
}) => {
  const session = useContext(SessionContext)?.session;

  return (
    <View style={styles.container}>
      <View style={styles.badge}>
        <NormalText text="Free Plan Tip" style={styles.badgeText} />
      </View>
      <TitleText
        text="Looks like you're testing the simulator"
        style={styles.header}
        fontWeight="600"
      />
      <NormalText
        text="Want patients to do this on your website? Install the lead-gen widget in a few minutes and start capturing leads automatically."
        style={styles.body}
      />
      <PrimaryButton
        text="Install Widget"
        fullWidth
        onPress={() => {
          mixpanel.track("Deploy Widget Nudge Clicked", {
            "User Email": session?.userEmail,
            clinic: session?.clinicName,
            source: "simulation_threshold_modal",
          });
          window.location.href = "/deploy-widget";
        }}
      />
      <SecondaryButton
        text="Maybe Later"
        style={styles.secondaryButton}
        fullWidth
        onPress={onClose}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: "#FFFFFF",
    padding: 24,
    borderRadius: 16,
    width: "100%",
    maxWidth: 520,
    alignItems: "center",
  },
  badge: {
    backgroundColor: "#A1E3CB",
    borderRadius: 999,
    paddingHorizontal: 12,
    paddingVertical: 6,
    marginBottom: 12,
  },
  badgeText: {
    color: "#000000",
    fontFamily: "Urbanist600",
    fontSize: 13,
  },
  header: {
    textAlign: "center",
    marginBottom: 12,
  },
  body: {
    textAlign: "center",
    marginBottom: 20,
    color: "#1D252D",
    maxWidth: 440,
  },
  secondaryButton: {
    marginTop: 12,
  },
});

export default DeployWidgetNudgeModal;
